<template>
	<div>
		<v-tooltip v-if="showProgress" bottom>
			<template v-slot:activator="{ on }">
				<v-progress-circular :rotate="360" :size="50" :width="5" :value="progress" :color="color" v-on="on">{{ `${progress}%` }}</v-progress-circular>
			</template>
			<span>{{ tooltip }}</span>
		</v-tooltip>
	</div>
</template>

<script>
	export default {
		props: {
			goal: {
				type: Object,
				required: true
			}
		},
		computed: {
			showProgress() {
				if (this.goal !== null) {
					return !this.goal.complete;
				}
				return false;
			},
			progress() {
				if (this.goal !== null) {
					if (this.goal.kpis !== null && this.goal.kpis.length > 0) {
						const complete = this.goal.kpis.filter(x => x.complete === true).length;
						return Math.round((complete / this.goal.kpis.length) * 100);
					}
				}
				return 0;
			},
			color() {
				return this.progress === 100 ? 'success' : 'primary';
			},
			tooltip() {
				if (this.goal !== null) {
					if (this.goal.kpis !== null && this.goal.kpis.length > 0) {
						const complete = this.goal.kpis.filter(x => x.complete === true).length;
						return `${complete}/${this.goal.kpis.length} KPI's complete`;
					}
				}
				return "No KPI's have been setup for this goal";
			}
		}
	};
</script>

<style scoped></style>
